import { useState, useEffect } from "react";
import { useRef } from "react";
import axios from 'axios'
import "./Complaints.css" ; 
import Icon from "./Icon.jsx";


function Complaints({id, csrfToken}) {
  const [isOpenMenu, setIsOpenMenu] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const formRef = useRef(null)
  
  const toggleOpenMenu = ()  =>{
    setIsOpenMenu(!isOpenMenu)
  }
  useEffect(() => {
    setIsOpenMenu(false)
    setIsError(false)
    setIsSuccess(false)
  }, [])

  useEffect(() => {
    if (isError || isSuccess) {
      const timer = setTimeout(() => {
        if (isError) {
          setIsError(false);
        }
        if (isSuccess) {
          setIsSuccess(false);
        }
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [isError, isSuccess]);
  
  
  const CSRF_TOKEN = csrfToken
  const sendComplaints = () =>{
    const form = formRef.current
    if(form){
      const formData = new FormData(form);
      const complainType = formData.entries().next().value[1];
      const data = {
        command: 'complain',
        content_type: 'proposals',
        object_id: id,
        complaint_type: complainType
      };
      
      const payload = new URLSearchParams(data).toString();
      async function sendData(payload) {
        try {
          const response = await axios.post('.', payload, {
            headers: {
              'X-CSRFToken': CSRF_TOKEN,
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              'X-Requested-With': 'XMLHttpRequest'
            },
            withCredentials: true
          });
          setIsSuccess(true)
          setIsError(false)
          setIsOpenMenu(false)
          // `response.data` contiene la respuesta del servidor en formato JSON
          return response.data;
        } catch (error) {
          console.error('Error al enviar los datos:', error);
          setIsError(true)
          setIsSuccess(false)
          setIsOpenMenu(false)
          throw error;
        }
      }
      sendData(payload)
    }
  }

  return (
    <>
      <div className="complaints-react">
        <div
          id={`complaints-react-message-post-${id}`}
          className="complaints-react-message"
          style={{display: "none"}}
        ></div>
        {isError && 
          <div className="complaints-react-message error" >
            Error al enviar la denuncia.
          </div>
        }
        {isSuccess &&
          <div className="complaints-react-message success" >
            El comentario ha sido denunciado con éxito.
          </div>
        }
        <button className="complaints-react-expand-btn" type="button" onClick={toggleOpenMenu}> 
          Denunciar
          <Icon/>
        </button>
        {isOpenMenu &&
          <form
            id={`complaints_form_post_${id}`}
            className="complaints-react-form"
            ref={formRef}
          >
            <label
              className="complaints-react-label"
              htmlFor={`complaints-react-${id}_1`}
            >
              <input
                className="complaints-react-input"
                type="radio"
                id={`complaints-react-${id}_1`}
                name={`complaints-react-${id}`}
                value="odio"
              />
              <span className="complaints-react-span">Delito de odio</span>
            </label>
            <label
              className="complaints-react-label"
              htmlFor={`complaints-react-${id}_2`}
            >
              <input
                className="complaints-react-input"
                type="radio"
                id={`complaints-react-${id}_2`}
                name={`complaints-react-${id}`}
                value="falso"
              />
              <span className="complaints-react-span">Informacion falsa</span>
            </label>
            <label
              className="complaints-react-label"
              htmlFor={`complaints-react-${id}_3`}
            >
              <input
                className="complaints-react-input"
                type="radio"
                id={`complaints-react-${id}_3`}
                name={`complaints-react-${id}`}
                value="spam"
              />
              <span className="complaints-react-span">Spam</span>
            </label>
            <div className="complaints-react-form-footer">
              <button className="complaints-react-submit-btn" type="button" onClick={sendComplaints}>
                Enviar
              </button>
              <button
                className="complaints-react-cancel-btn"
                id="complaintsCancelBtn"
                type="button"
                onClick={()=>{
                  setIsOpenMenu(false)
                }}
              >
                Cancelar
              </button>
            </div>
          </form>
        }
      </div>
    </>
  );
}

export default Complaints;
